export default function(val) {
  if (typeof val === 'string' || val instanceof String) {
    const expression = /[(http(s)?)://(www.)?a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/;
    return expression.test(val);
  } else {
    return false;
  }
}
